module.exports = __webpack_public_path__ + "assets/img/6_637.63c2d188.jpg";